module.exports = require("react-dnd");